module.exports = __webpack_public_path__ + "static/media/esm_ancient_game_metal_thin_strip_twist_sequence_4_squeak_crank_gear_open_slide_texture.109c7406.wav";